import Lazyload from 'vue-lazyload';
export default Lazyload;


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant/es/lazyload/index.js
// module id = 339
// module chunks = 140